import * as React from 'react';
import { SVGProps } from 'react';

const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m13.908 5.8 1.647 1.8H19.2v10.8H4.8V7.6h3.645l1.647-1.8h3.816zM14.7 4H9.3L7.653 5.8H4.8c-.99 0-1.8.81-1.8 1.8v10.8c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V7.6c0-.99-.81-1.8-1.8-1.8h-2.853L14.7 4zM12 10.3c1.485 0 2.7 1.215 2.7 2.7s-1.215 2.7-2.7 2.7-2.7-1.215-2.7-2.7 1.215-2.7 2.7-2.7zm0-1.8c-2.484 0-4.5 2.016-4.5 4.5s2.016 4.5 4.5 4.5 4.5-2.016 4.5-4.5-2.016-4.5-4.5-4.5z" />
  </svg>
);

export default SvgCamera;
